import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { HoldingClass, Partner, Transaction } from 'types';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

import operationTypes from 'constants/operationTypes';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

type CapitalVariationOperationTableRowProps = {
  index: number;
  transaction: Transaction;
};

const CapitalVariationOperationTableRow: FC<
  CapitalVariationOperationTableRowProps
> = ({ index, transaction }) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { data } = useOperationDetailsPage();

  const isIncrease =
    data.operation?.operationType === operationTypes.CAPITAL_INCREASE ||
    data.operation?.operationType === operationTypes.CONSTITUTION;

  const { partner, shareFrom, shareTo, shareClass, sharePremium, sharePrice } =
    transaction;

  const partnerId = (partner as Partner)?._id || '';
  const partnerName = (partner as Partner)?.name || '';
  const sharesCount = (shareTo || 0) - (shareFrom || 0) + 1;
  const className = (shareClass as HoldingClass)?.name || '';

  const sharesCountRowValue = isIncrease ? sharesCount : -sharesCount;
  const shareValue = isIncrease ? sharePremium : sharePrice;

  return (
    <>
      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`participant-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
        >
          {partnerName}
        </Link>
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`shares-count-${index}`}
      >
        {formatNumber(sharesCountRowValue)}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`share-from-${index}`}
      >
        {formatNumber(shareFrom || 0)}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`share-to-${index}`}
      >
        {formatNumber(shareTo || 0)}
      </td>

      <td
        className="text-center vertical-align-middle"
        key={`class-name-${index}`}
      >
        {className}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`shares-value-${index}`}
      >
        {formatCurrencyDecimals(shareValue || 0)}
      </td>
    </>
  );
};
export default CapitalVariationOperationTableRow;
